import React, { memo, useMemo, useState, useEffect, useRef } from "react";
import { ConceptRail } from "./ConceptRail";
import {useSearchParams} from "react-router-dom";
import { TranscriptBlocks } from "./TranscriptBlocks";

const PodCastTextContent = ({ podCastTextContentProps }) => {
  const { audioPlayerCopy, audioText, timestampClickHandler } =
    podCastTextContentProps;
  
  const tresholdScoreFilterer = useTresholdScoreFilterer();
  const entityTypeFilterer = useEntityTypeFilterer();

  const sections = 
    audioText
      .map(s => ({...s, 
          conceptList:
          entityTypeFilterer(
            tresholdScoreFilterer(s.conceptList))
          }));

  const hasConcepts = useMemo(() => {
    return sections.filter(s => s.conceptList?.length > 0).length !== 0;
  }, [audioText]);


  return (
    <div className="w-full  my-2 grid grid-cols-earningsCallText grid-rows-1 grid-flow-col gap-x-1 justify-start text-customFontEleven text-black">
      <div className="w-full bg-linen p-1">
        <div style={{maxHeight:"calc(100vh - 165px)"}} className={[..."w-full overflow-auto scrollbar-hide rounded-md max-h-screen".split(" ")].join(" ")}>
          {<TranscriptBlocks transcriptionSections={sections} jumpToAudio={timestampClickHandler} 
          audioPlayer={audioPlayerCopy} />}
        </div>
      </div>
      {
          hasConcepts ?
          <div style={{maxHeight:"calc(100vh - 165px)"}} className="md:w-48 w-32 bg-linen py-1 bg-inherit max-h-screen overflow-auto scrollbar-hide rounded-md">
            <div className="w-full">{<ConceptRail sentences={sections} jumpToAudio={timestampClickHandler} />}</div>
          </div> : ""
      }
    </div>
  );
};

export const useTresholdScoreFilterer = () => {
  const [searchParams] = useSearchParams();
  const scoreTresholdStr = searchParams.get('score_treshold');
  const scoreTreshold = scoreTresholdStr ? parseFloat(scoreTresholdStr) : null;
  
  return (conceptList) => {
      if(!(conceptList) || conceptList.length === 0)
      return conceptList;

      if(isNaN(scoreTreshold))
          return conceptList;
  
      return conceptList.filter(c => c.score === undefined || c.score >= scoreTreshold);
  };
}

const useEntityTypeFilterer = () => {
  const [searchParams] = useSearchParams();
  const entityFilterStr = searchParams.get('entity_filter');
  const entityTypeArr = entityFilterStr ? entityFilterStr.split(",") : [];

  return (conceptList) => {
    if(entityTypeArr.length === 0)
      return conceptList;
    if(!(conceptList) || conceptList.length === 0)
      return conceptList;

    return conceptList.filter(c => 
        c.conceptType !== "ENTITY" || entityTypeArr.find(et => et === c.entityType));
  }

}

export default memo(PodCastTextContent);
